import { useLayoutEffect, useRef } from "react";

export const TextField = ({ id, label, value, onChange, type = "text", testid, className = "", ...rest }) => (
  <div className={`flex flex-col gap-1.5 ${className}`}>
    <label htmlFor={id} className="field-label">{label}</label>
    <input id={id} type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="field-input" data-testid={testid} {...rest} />
  </div>
);

export const AutoTextarea = ({ id, label, value, onChange, testid, placeholder, rows = 2, hideLabel = false }) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight + 4}px`;
  }, [value]);
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className={hideLabel ? "sr-only" : "field-label"}>{label}</label>
      <textarea ref={ref} id={id} rows={rows} value={value ?? ""} placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)} className="field-input resize-none leading-relaxed" data-testid={testid} />
    </div>
  );
};

export const Pills = ({ legend, name, options, value, onChange, testid, hideLegend = true }) => (
  <fieldset>
    <legend className={hideLegend ? "sr-only" : "field-label mb-2"}>{legend}</legend>
    <div className="flex flex-wrap gap-2">
      {options.map((o) => (
        <label key={o.v} className={`pill-opt tone-${o.tone || "brand"} ${value === o.v ? "is-on" : ""}`} data-testid={`${testid}-${o.v}`}>
          <input type="radio" name={name} value={o.v} checked={value === o.v} onChange={() => onChange(o.v)} className="sr-only" />
          {o.tone && o.tone !== "brand" && <span className={`dot dot-${o.tone}`} aria-hidden="true" />}
          <span>{o.label}</span>
          {o.hint && <span className="text-xs opacity-90">· {o.hint}</span>}
        </label>
      ))}
    </div>
  </fieldset>
);

export const RAG_OPTIONS = [
  { v: "red", label: "Red", hint: "Priority action", tone: "red" },
  { v: "amber", label: "Amber", hint: "Review needed", tone: "amber" },
  { v: "green", label: "Green", hint: "Working well", tone: "green" },
];

export const Stat = ({ label, value, tone, testid }) => (
  <div className="rounded-2xl border-2 border-line bg-surface p-4" data-testid={testid}>
    <p className="flex items-center gap-2 text-sm font-bold text-ink-soft">{tone && <span className={`dot dot-${tone}`} aria-hidden="true" />}{label}</p>
    <p className="mt-1 font-display text-4xl font-medium">{value}</p>
  </div>
);
